let siteURL = process.env.REACT_APP_API_URL;
const currentURL = window.location.href;

// hotfix for redirecting to correct user service url based on respondent landing url
if (currentURL.includes('https://respondentlanding-hotfix.azurewebsites.net')) {
  siteURL = 'https://zampliauserservice-hotfix.azurewebsites.net/api/';
}

// eslint-disable-next-line no-console
console.log(process.env);

const appConfig = {
  siteURL,
  version: '1.1.15',
};

export default appConfig;
